// Define environment configuration for dev environment
export const environment = {
  production: false,
  auth: {
    clientID: '95pzTqGyHzWbEoy4nIcUsOFzDYw3Tkpg',
    audience: 'https://pricefx.growthfuel.app',
    domain: 'ra-gf.us.auth0.com',
    algorithm: 'RSA256',
    responseType: 'token id_token',
    scope: 'openid profile email',
  },
  api: 'https://api.dev.growthfuel.app',
  env: 'dev',
  features: {
    aidaEnabled: true, // Enable AIDA in development environment
    dashboardConfigEnabled: true, // Enable Dashboard Config in development environment
    etlConfigEnabled: true, // Enable ETL Config in development environment
  },
};
